export default () => ({
    '& h3': {
        display: 'flex',
        justifyContent: 'space-between',
    },
    '& .news-tags': {
        display: 'block',
        marginBottom: '1rem',
    },
    '& .news-image': {
        float: 'left',
        margin: '0 1rem 1rem 0',
    },
});
